<div [ngClass]="{'p-2':!hideCreate}">

  <div class="d-flex align-items-center">
    @if (!onlyTable) {
      <span class="me-2">{{'db.table'|translate}}:</span>
      <s-select [items]="tables" [customOption]="tableOption" [(model)]="selectedTable" (change)="tableChange()"
        [clearable]="false" customClass="min-w-15">
      </s-select>
    }
    @if (!hideCreate && this.selectedTable) {
      <button class="btn btn-primary px-4 ms-auto" (click)="addRow()">
        <i class="bi bi-plus"></i>
        {{'db.add_row'|translate}}
      </button>
    }
  </div>

  <div class="overflow-x-auto wrapper">
    <s-table #table [cols]="cols" [refreshUrl]="refreshUrl" [params]="extra" (onResponse)="onResponse($event)"
      [hideRows]="true" [convertOrig]="true" [convertStatic]="false">

      <ng-template let-row let-rowRaw="raw" #slotTh>
        <th></th>
      </ng-template>
      <ng-template let-row let-rowRaw="raw" let-index="index" #slotRow>
        <tr [class]="row.trClass">
          <td>
          </td>
          @for (col of cols; track col) {
            <td>
              @if (!(col.disabledAll || (col.disabledExisting && !rowRaw.isNew) || row.disabled)) {
                <s-input [type]="col.type" [(model)]="rowRaw[col.attr]" [disabled]="col.disabled" [required]="true"
                  [required]="col.required" [bindLabel]="col.bindLabel" [bindValue]="col.bindValue" [items]="col.options"
                  appendTo="body" [multiple]="col.multiple" [customClass]="(!col.type || col.type=='text')?'min-w-10':''"
                  >
                </s-input>
              } @else {
                {{row[col.attr]}}
              }
              <ng-template #disabled>{{row[col.attr]}}</ng-template>
            </td>
          }
          <td>
            @if (!row.disabled && !disabled) {
              <div class="d-flex align-items-center justify-content-end">
                <button class="btn btn-sm btn-success me-2" ngbTooltip="{{'save' |translate}}"
                  (click)="saveRow(row, rowRaw)">
                  <i class="bi bi-save"></i>
                </button>
                @if (rowRaw.isNew) {
                  <button class="btn btn-sm btn-secondary  me-2" ngbTooltip="{{'cancel' |translate}}"
                    (click)="cancelRow(index)">
                    <i class="bi bi-x-circle"></i>
                  </button>
                }
                @if (!rowRaw.isNew) {
                  <button class="btn btn-sm btn-secondary  me-2" ngbTooltip="{{'copy' |translate}}"
                    (click)="copyRow(rowRaw)">
                    <i class="bi bi-files"></i>
                  </button>
                }
                @if (!rowRaw.isNew) {
                  <button class="btn btn-sm btn-danger  me-2" ngbTooltip="{{'delete' |translate}}"
                    (click)="deleteRow(rowRaw)">
                    <i class="bi bi-trash"></i>
                  </button>
                }
              </div>
            }
          </td>
        </tr>
      </ng-template>

    </s-table>
  </div>

</div>
